<template>
  <div class="font-athiti h-screen flex">
    <NotificationContainer />
    <TheSidebar />
    <div class="bg-gray-100 flex-1 flex flex-col overflow-y-hidden">
      <TheHeader />
      <transition name="slide" mode="out-in">
        <router-view />
      </transition>
    </div>
  </div>
</template>

<script>
import TheSidebar from '@/components/TheSidebar'
import TheHeader from '@/components/TheHeader'
import NotificationContainer from '@/components/NotificationContainer'

export default {
  components: {
    TheSidebar,
    TheHeader,
    NotificationContainer,
  },
}
</script>

<style>
/* router view animation */
.slide-enter-active {
  animation: slide-in 200ms ease-out forwards;
}

.slide-leave-active {
  animation: slide-out 200ms ease-out forwards;
}

@keyframes slide-in {
  from {
    transform: translateY(-30px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

@keyframes slide-out {
  from {
    transform: translateY(0);
    opacity: 1;
  }
  to {
    transform: translateY(-30px);
    opacity: 0;
  }
}
/* end router view animation */
</style>
